<template>
    <v-row
        justify="center"
    > 
        <v-col>
            <v-card
                class="mx-auto water-mark"
                width="800"               
            >
                <v-card-title
                    class="d-flex white--text  py-2 px-0 primary"
                >
                    <v-spacer></v-spacer>
                    <div class="caption font-weight-light text-uppercase">Employee Attendance</div>
                    <v-spacer></v-spacer>
                              
                </v-card-title>        
                
                <div class="d-flex justify-center mt-4">
                    <v-card width="400" class="pa-3 mr-4 d-flex" flat outlined rounded="lg">
                        <span class="mr-6">
                            <DatePicker 
                                label="Start Date"
                                :selected-date="attendanceDates[0]"
                                @date-selected="setAttendanceStartDate"
                                :initial-allowed-dates="allowedDates"
                            ></DatePicker>        
                        </span>
                    
                        <span>
                            <DatePicker 
                                label="End Date"
                                :selectedDate="attendanceDates[1]"
                                @date-selected="setAttendanceEndDate"
                                :initial-allowed-dates="allowedDates"
                            ></DatePicker>        
                        </span>
                    </v-card>
                </div>

                <div class="d-flex justify-center">
                    <v-card
                        class="mt-3 pa-3"
                        width="700"
                        flat
                    >
                        <v-data-table
                            :headers="headers"
                            :items="records"
                            :loading="loading"  
                            height="45vh"
                            fixed-header
                            class="custom-table"
                            no-data-text="No records found for the period selected"
                        >
                            
                        </v-data-table>

                        <v-card-actions class="mt-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                dark
                                @click="displayReport"
                            >
                                Display Report
                            </v-btn>
                        </v-card-actions>
                    </v-card>  
                </div>
            </v-card>
            
            <v-dialog
                v-model="dialog"
                max-width="90vw"
                persistent            
            >
                <v-card v-if="dialog" height="85vh" class="pb-0">
                    <iframe 
                        ref="pdf" 
                        style="width:100%; height:92%" 
                        frameBorder="0" 
                        :src="src"
                        @load="pdfLoaded"
                    ></iframe>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            color="error"
                            small
                            @click="closeReport"
                        >
                            Close Report
                        </v-btn>

                    </v-card-actions>

                    
                    <v-overlay
                        absolute
                        :value="overlay"
                        color="white"
                        opacity="0.60"
                    >
                        <v-progress-circular
                            indeterminate
                            size="64"
                            color="primary"
                        ></v-progress-circular>
                    </v-overlay>                            
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>

    
</template>

<script>
import DatePicker from './DatePickerAttendance';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'attendance',
    components: {
        DatePicker
    },

    created: function () {
        this.initialize();
    },

    data: function(){
        return {
            records: [],
            headers:[
                { text: 'Date', value: 'attendance_date', sortable: false, width: 120 },
                { text: 'Time In (AM)', value: 'attendance_time_am', sortable: false },
                { text: 'Mins. Late(AM)', value: 'late_minutes_am', sortable: false },
                { text: 'Status AM', value: 'status_am', sortable: false },
                { text: 'Time In (PM)', value: 'attendance_time_pm', sortable: false },
                { text: 'Mins. late(PM)', value: 'late_minutes_pm', sortable: false },
                { text: 'Status PM', value: 'status_pm', sortable: false },
                { text: 'Status (Day)', value: 'status_day', sortable: false },
            ],
            loading: false,
            attendanceDates: [],
            labelStartDate: 'Start Date',
            labelEndDate: 'End Date',
            allowedDates: [],
            dialog: false,
            overlay: false,
        }
    },

    computed: {
        ...mapGetters({
            employeeId: 'auth/getEmployeeId',
            employeeRecord: 'auth/getEmployeeRecord',
        })
    },

    methods: {
        
        ...mapActions({
            getAttendanceData: 'attendanceEmployee/getAttendanceData',
            getAllowedDates: 'attendanceEmployee/getAllowedDates',
        }),

        ...mapMutations({
            setAttendanceDates: 'attendanceEmployee/setAttendanceDates',
        }),


        async initialize () {
            this.setDefaultAttendanceDates();
            this.setAttendanceDates(this.attendanceDates);
            this.getAttendanceRecords();
            console.log('employee record', this.employeeRecord);
        },

        async getAttendanceRecords () {
            this.setAttendanceDates(this.attendanceDates);
            this.loading = true;
            try {
                const [
                    { data: dataAttendanceData },
                    { data: dataAllowedDates }
                ] = await Promise.all([
                    this.getAttendanceData(),
                    this.getAllowedDates()
                ])
                this.records = dataAttendanceData;
                this.allowedDates = dataAllowedDates;
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            } finally {
                this.loading = false;
            }
        },

        setDefaultAttendanceDates(){
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            const format = (date) => date.toISOString().split('T')[0];
            this.attendanceDates = [format(startOfMonth), format(endOfMonth)];
        },

        setAttendanceStartDate(date){
            this.attendanceDates[0] = date;
            if(this.attendanceDates.length == 2) this.getAttendanceRecords();
        },

        setAttendanceEndDate(date){
            this.attendanceDates[1] = date;
            if(this.attendanceDates.length == 2) this.getAttendanceRecords();
        },

        displayReport (){
            const baseUrl = process.env.VUE_APP_API_URI  + '/api/';
            let startDate = this.attendanceDates[0];
            let endDate = this.attendanceDates[1];
            this.dialog = true;
            if(this.employeeRecord.staff_type == 'Teacher'){
                this.src = `${baseUrl}employee-attendance-report/teacher?start_date=${startDate}&end_date=${endDate}&teacher_num=${this.employeeRecord.teacher_num}`;
            }
            else{
                this.src = `${baseUrl}employee-attendance-report/auxillary?start_date=${startDate}&end_date=${endDate}&employee_number=${this.employeeRecord.employee_number}`;
            }
            this.overlay = true;
        },

        pdfLoaded () {
            this.overlay = false;
        },

        closeReport () {
            this.dialog = false;
            this.src = '';
        }

        
    }
}
</script>>